import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDfwH4arkt_YIK3_f6BdQHK6c-KiBdTY-Q',
  authDomain: 'advertizer-1671c.firebaseapp.com',
  projectId: 'advertizer-1671c',
  storageBucket: 'advertizer-1671c.appspot.com',
  messagingSenderId: '231891765261',
  appId: '1:231891765261:web:f30208be0a0639f0df2d44'
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export default app
